import {
    FolderViewState,
    getFolderViewStatesFromUserConfig,
} from '../actions/folderViewStatesActions';
import { MailSortHelper, SortBy } from 'owa-mail-list-store';
import { getSupportedSortColumns } from 'owa-mail-list-store/lib/utils/sort/mailSortHelper';
import isSortingPersisted from '../utils/isSortingPersisted';

export default function getSortByFolderId(folderId: string): SortBy {
    if (isSortingPersisted()) {
        const sessionDataViewStates = getFolderViewStatesFromUserConfig();
        const folderViewState: FolderViewState = sessionDataViewStates[folderId];
        // If we do not have a viewstate for this folder, use the sort column / order default.
        if (folderViewState) {
            const supportedSortColumns = getSupportedSortColumns(folderId);
            const { SortColumn, SortOrder } = folderViewState;
            // Use sort column given by folder view state only if we support it in React. Otherwise, use default.
            if (supportedSortColumns.includes(SortColumn)) {
                return { sortColumn: SortColumn, sortDirection: SortOrder };
            }
        }
    }
    return MailSortHelper.getDefaultSortBy();
}
